import { FC } from 'react';
import SimpleForm, { SimpleFormProps } from './simpleForm';
import SimpleFormInput, { SimpleFormInputProps } from './input';
import SimpleFormInputNumber, {
  SimpleFormInputNumberProps,
} from './inputNumber';
import SimpleFormSwitch, { SimpleFormSwitchProps } from './switch';
import SimpleFormSelect, { SimpleFormSelectProps } from './select';
import SimpleFormSuperSelect, { SimpleFormSuperSelectProps } from './superSelect';
import SimpleFormSelectTable, {
  SimpleFormSelectTableProps,
} from './selectTable';
import SimpleFormSuperSelectTable, {
  SimpleFormSuperSelectTableProps,
} from './superSelectTable';
import SimpleFormTextArea, { SimpleFormTextAreaProps } from './textArea';
import SimpleFormDatePicker, { SimpleFormDatePickerProps } from './datePicker';
import SimpleFormRangePicker, {
  SimpleFormRangePickerProps,
} from './rangePicker';
import SimpleFormTimePicker, { SimpleFormTimePickerProps } from './timePicker';
import SimpleFormCheckbox, { SimpleFormCheckboxProps } from './checkbox';
import SimpleFormCheckboxGroup, {
  SimpleFormCheckboxGroupProps,
} from './checkboxGroup';
import SimpleFormUpload, { SimpleFormUploadProps } from './upload';
import SimpleFormUploadImage, {
  SimpleFormUploadImageProps,
} from './uploadImage';
import SimpleFormUploadImages, {
  SimpleFormUploadImagesProps,
} from './uploadImages';
import SimpleFormCascader, { SimpleFormCascaderProps } from './cascader';
import SimpleFormSelectCustom, { SimpleFormSelectCustomProps } from './selectCustom';
import SimpleFormDropdownTable, { SimpleFormDropdownTableProps } from './dropdownTable';
import SimpleFormDropdownSyncTable, { SimpleFormDropdownSyncTableProps } from './dropdownSyncTable';
import SimpleFormSuperSelectCombination, { SimpleFormSuperSelectCombinationProps } from './selectCombination';
import SimpleFormSuperAutoComplete, { SimpleFormSuperAutoCompleteProps } from './superAutoComplete';

export interface SimpleFormItemProps
  extends SimpleFormInputProps,
    SimpleFormInputNumberProps,
    SimpleFormSwitchProps,
    SimpleFormSelectProps,
    SimpleFormSuperSelectProps,
    SimpleFormSelectTableProps,
    Omit<SimpleFormSuperSelectTableProps, 'name'>,
    SimpleFormTextAreaProps,
    SimpleFormDatePickerProps,
    SimpleFormRangePickerProps,
    SimpleFormTimePickerProps,
    SimpleFormCheckboxProps,
    SimpleFormCheckboxGroupProps,
    SimpleFormUploadProps,
    SimpleFormUploadImageProps,
    SimpleFormUploadImagesProps,
    SimpleFormCascaderProps,
    SimpleFormSelectCustomProps,
    SimpleFormDropdownTableProps,
    SimpleFormDropdownSyncTableProps,
    SimpleFormSuperSelectCombinationProps,
    SimpleFormSuperAutoCompleteProps {}

export type ISimpleFormComponent = FC<SimpleFormProps> & {
  Input: FC<SimpleFormInputProps>;
  InputNumber: FC<SimpleFormInputNumberProps>;
  Switch: FC<SimpleFormSwitchProps>;
  Select: FC<SimpleFormSelectProps>;
  SuperSelect: FC<SimpleFormSuperSelectProps>;
  SelectTable: FC<SimpleFormSelectTableProps>;
  SuperSelectTable: FC<SimpleFormSuperSelectTableProps>;
  TextArea: FC<SimpleFormTextAreaProps>;
  DatePicker: FC<SimpleFormDatePickerProps>;
  RangePicker: FC<SimpleFormRangePickerProps>;
  TimePicker: FC<SimpleFormTimePickerProps>;
  Checkbox: FC<SimpleFormCheckboxProps>;
  CheckboxGroup: FC<SimpleFormCheckboxGroupProps>;
  Upload: FC<SimpleFormUploadProps>;
  UploadImage: FC<SimpleFormUploadImageProps>;
  UploadImages: FC<SimpleFormUploadImagesProps>;
  Cascader: FC<SimpleFormCascaderProps>;
  SelectCustom: FC<SimpleFormSelectCustomProps>;
  DropdownTable: FC<SimpleFormDropdownTableProps>;
  DropdownSyncTable: FC<SimpleFormDropdownSyncTableProps>;
  SelectCombination: FC<SimpleFormSuperSelectCombinationProps>;
  SuperAutoComplete: FC<SimpleFormSuperAutoCompleteProps>;
};
/** 简单表单 */
const TransSimpleForm = SimpleForm as ISimpleFormComponent;
TransSimpleForm.Input = SimpleFormInput;
TransSimpleForm.InputNumber = SimpleFormInputNumber;
TransSimpleForm.Switch = SimpleFormSwitch;
TransSimpleForm.Select = SimpleFormSelect;
TransSimpleForm.SuperSelect = SimpleFormSuperSelect;
TransSimpleForm.SelectTable = SimpleFormSelectTable;
TransSimpleForm.SuperSelectTable = SimpleFormSuperSelectTable;
TransSimpleForm.TextArea = SimpleFormTextArea;
TransSimpleForm.DatePicker = SimpleFormDatePicker;
TransSimpleForm.RangePicker = SimpleFormRangePicker;
TransSimpleForm.TimePicker = SimpleFormTimePicker;
TransSimpleForm.Checkbox = SimpleFormCheckbox;
TransSimpleForm.CheckboxGroup = SimpleFormCheckboxGroup;
TransSimpleForm.Upload = SimpleFormUpload;
TransSimpleForm.UploadImage = SimpleFormUploadImage;
TransSimpleForm.UploadImages = SimpleFormUploadImages;
TransSimpleForm.Cascader = SimpleFormCascader;
TransSimpleForm.SelectCustom = SimpleFormSelectCustom;
TransSimpleForm.DropdownTable = SimpleFormDropdownTable;
TransSimpleForm.DropdownSyncTable = SimpleFormDropdownSyncTable;
TransSimpleForm.SelectCombination = SimpleFormSuperSelectCombination;
TransSimpleForm.SuperAutoComplete = SimpleFormSuperAutoComplete;

export default TransSimpleForm;
